export default __webpack_public_path__ + "static/media/T124_CoC.4bb61c8a.pdf";